// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2ITz1","header":"MessagesList_header__3Xw9P","chat":"MessagesList_chat__2Xefo"};